import FarmReportList from "../../slices/report/farm_report/FarmReportList";
import CropPlaningReportList from "../../slices/report/crop_planing_report/CropPlaningReportList";
import ConstructionReportList from "../../slices/report/construction_report/ConstructionReportList";

const reportReducer = {
    farmReportList: FarmReportList,
    cropPlaningReportList: CropPlaningReportList,
    constructionReportList: ConstructionReportList,
};

export default reportReducer;